import '../../core/styles/focusRingStatic.css';
import './Link.css';
export var link = '_1iksxp40-3-5-0 _z0fq9b4-3-5-0 _z0fq9be-3-5-0 _z0fq9b5-3-5-0 _z0fq9b9-3-5-0';